export default __webpack_public_path__ + "static/how_it_works_step_7_mobile-74e97f7d8f2b3f5bd697dd638a550a4b.webp";